<template>
  <!-- 查看文件  -->
  <div class="lookFileToast" width="100%">
    <div class="content">
      <!-- <i class="el-icon-close close" @click="closeEvent"></i> -->
      <video :src="file_url" v-if="fileType == 5" style="margin: auto;display: block;max-width: 90%;" preload="meta" autoplay controls="controls">您的浏览器不支持 video 标签。</video>
      <!-- 图片预览 -->
      <img :src="file_url" v-else-if="fileType == 4" style="width:100%;margin:auto;" />
      <!-- pdf预览 -->
      <iframe frameborder='no' :src="file_url" width="100%" height='100%' v-else-if="fileType==1" style="height:100vh;"></iframe>
      <!-- docx/xlsx/xls -->
      <iframe v-else-if="fileType==2" :src="`https://view.officeapps.live.com/op/view.aspx?src=${file_url}`" width='100%' height='100%' frameborder='1' style="height:100vh;"></iframe>
      <!-- .csv  -->
      <el-table height="100vh" v-else-if="fileType==3" ref="multipleTable" :data="csvData" border style="width: 100%">
        <el-table-column v-for="(item,index) in csvTh" :key="index" align="center" :label="item" width="180px" show-overflow-tooltip>
          <template slot-scope="scope">
            {{(scope.row)[index]}}
          </template>
        </el-table-column>
      </el-table>
      <iframe v-else :src="`https://view.officeapps.live.com/op/view.aspx?src=${file_url}`" width='100%' height='100%' frameborder='1' style="height:100vh;"></iframe>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      fileType: '',
      csvTh: [],
      csvData: [],
      file_url: ''
    }
  },
  mounted () {
    this.fileUrl = this.$route.query.url + '#view=FitH,top';
    if (this.fileUrl) {
      this.init()
    }
  },
  methods: {
    init () {
      var data = this.fileUrl;
      data = data.replace("http://", window.location.protocol + '//')
      var _this = this;
      this.fileType = '';
      this.csvTh = [];
      this.csvData = [];
      var url = data;
      this.file_url = data;
      url.indexOf('.txt') != -1 || url.indexOf('.pdf') != -1 || url.indexOf('.PDF') != -1 || url.indexOf('.html') != -1 ? this.fileType = 1 : '';//txt pdf html
      url.indexOf('.doc') != -1 || url.indexOf('.xls') != -1 ? this.fileType = 2 : '';//docx/xlsx/xls/doc
      url.indexOf('.csv') != -1 ? this.fileType = 3 : '';//csv
      url.indexOf('.png') != -1 || url.indexOf('.jpg') != -1 || url.indexOf('.jpeg') != -1 ? this.fileType = 4 : '';//png jpg jpeg
      url.indexOf('.mp4') != -1 ? this.fileType = 5 : '';//mp4
      if (this.fileType == 3) {
        Papa.parse(url, {
          download: true,
          complete: function (results) {
            var data = results.data;
            _this.csvTh = data[0]
            _this.csvData = data.slice(1);
          }
        });
      }
    },
    closeEvent () {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="scss" scoped>
.lookFileToast {
  .content {
    width: 100%;
    margin: auto;
    background: #fff;
    overflow-y: auto;
    .close {
      position: fixed;
      top: 20px;
      right: 20px;
      font-size: 20px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/assembly/lookFile.vue